import { Mode } from '../data/modes';

export function displayModeName(mode: Mode, useTraditionalNames: boolean): string {
  if (useTraditionalNames) {
    if (mode === 'ionian') return 'Major';
    if (mode === 'aeolian') return 'Minor';
  }
  return mode.charAt(0).toUpperCase() + mode.slice(1);
}
